import React from 'react';
import Layout from "../../../components/Wrappers/Layout";
import BankMasterFilter from './BankMasterFilter';
import BankMasterList from './BankMasterList';

function BankMaster() {
  return (
    <Layout>
      <BankMasterFilter />
      <BankMasterList />
    </Layout>
  )
}

export default BankMaster